module.exports = __webpack_public_path__ + "static/img/third.18466ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/solution/third.png
// module id = t8//
// module chunks = 1